import React, { Component } from 'react';

import { Navbar } from "react-bootstrap";
import HeaderSession from "./Componentes/HeaderSession";
import logo from "../assets/img/logo-TAD-d.png";
/* import logo from "../assets/img/logo_menu.png"; */
import { Scrolltome } from '../funciones/ScrollFunction';

class HeaderHome extends Component {
    state = {
        sidebarExists: false,
        clase: "nav-absolute",
    }

    constructor (props) {
        super (props);
        Scrolltome((resp) => {
            this.setState({clase: resp})
        })
    }
    
    /* 

    mobileSidebarToggle = (e) => {
        if (this.state.sidebarExists === false) {
            this.setState({
              sidebarExists: true
            });
        }
        e.preventDefault();
        document.documentElement.classList.toggle("nav-open");
        let node = document.createElement("div");
        node.id = "bodyClick";
        node.onclick = function() {
            this.parentElement.removeChild(this);
            document.documentElement.classList.toggle("nav-open");
        };
        document.body.appendChild(node);
    } */

    render() { 
        return (
            <React.Fragment>
                <Navbar fluid={true} className={this.state.clase + " navbar-pc"} style={{height:70, padding:10, display:"block !important", backgroundColor:"#FFF"}}>
                    <Navbar.Header align="left">
                        <img src={logo} alt="Instututo_Logo" width="auto" height="50px" style={{paddingLeft: 20, paddingRight: 20}}/>          
                        {/* <Navbar.Toggle onClick={this.mobileSidebarToggle} /> */}
                    </Navbar.Header>
                    <Navbar.Collapse>
                        <HeaderSession right = {true}/>
                    </Navbar.Collapse>
                </Navbar>

                <div role="navigation" className="navbar-mobile">
                    <div id="menuToggle">
                        <input type="checkbox" />
                        <span-data />
                        <span-data />
                        <span-data />
                        <ul id="menu">
                            <HeaderSession right = {false}/>
                        </ul>
                    </div>
                </div> 
            </React.Fragment>
        );
    }
}
 
export default HeaderHome;


// WEBPACK FOOTER //
// ./src/site/HeaderHome.jsx